<template>
  <div class="qunti-huaxiang-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle">
      <div class="line">
        <div class="xingbiebili">
          <div class="chart-title">性别比例</div>
          <div class="chart-content">
            <XingbieBili
              id="xingbiebili"
              :chartData="xingbienianlinData"
              v-if="xingbienianlinData"
            />
          </div>
        </div>
        <div class="nianlinjiegou">
          <div class="chart-title">年龄结构</div>
          <Bar3d :chartData="nianlinjiegouData" v-if="nianlinjiegouData" />
        </div>
      </div>
      <div class="xingbienianlin single-line">
        <div class="chart-title">游客性别年龄金字塔</div>
        <XingbieNianlin
          height="240px"
          id="xingbienianlin"
          :chartData="xingbienianlinData"
          v-if="xingbienianlinData"
        />
      </div>
      <div class="line">
        <div class="hunyinzhuangtai">
          <div class="chart-title">游客群体婚姻状态分析</div>
          <Pie3d
            :chartData="hunyinzhuangtaiData"
            v-if="hunyinzhuangtaiData.length > 0"
          />
        </div>
        <div class="xingqubiaoqian">
          <div class="chart-title">游客兴趣标签</div>
          <div class="chart-content">
            <ol>
              <li
                :class="{ current: xingqubiaoqian_fenlei == 0 }"
                @click="xingqubiaoqian_fenlei = 0"
              >
                全体
              </li>
              <li
                :class="{ current: xingqubiaoqian_fenlei == 1 }"
                @click="xingqubiaoqian_fenlei = 1"
              >
                分类1
              </li>
              <li
                :class="{ current: xingqubiaoqian_fenlei == 2 }"
                @click="xingqubiaoqian_fenlei = 2"
              >
                分类2
              </li>
              <li
                :class="{ current: xingqubiaoqian_fenlei == 3 }"
                @click="xingqubiaoqian_fenlei = 3"
              >
                分类3
              </li>
              <li
                :class="{ current: xingqubiaoqian_fenlei == 4 }"
                @click="xingqubiaoqian_fenlei = 4"
              >
                分类4
              </li>
              <li
                :class="{ current: xingqubiaoqian_fenlei == 5 }"
                @click="xingqubiaoqian_fenlei = 5"
              >
                分类5
              </li>
            </ol>
            <ul>
              <li class="biaotou">
                <div>兴趣偏好</div>
                <div>人数</div>
                <div>占比</div>
              </li>
              <li :key="index" v-for="(item, index) in xingqubiaoqianData">
                <div>{{ item.name }}</div>
                <div class="light-text">{{ item.count }}</div>
                <div class="light-text">{{ item.proportion }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import XingbieBili from "@/components/Echarts/XingbieBili.vue";
import XingbieNianlin from "@/components/Echarts/XingbieNianlin.vue";
import Pie3d from "@/components/Highcharts/Pie3d.vue";
import Bar3d from "@/components/Mycharts/Bar3d.vue";

export default {
  name: "QuntiHuaxiangDetail",
  components: {
    ChildModal,
    XingbieBili,
    XingbieNianlin,
    Pie3d,
    Bar3d
  },
  props: {},
  data() {
    return {
      nianlinjiegouData: null,
      xingbienianlinData: null,
      hunyinzhuangtaiData: [],
      xingqubiaoqian_fenlei: 0,
      xingqubiaoqianData: []
    };
  },
  mounted() {
    // 请求年龄结构
    fetch("/data/Home/QuntiHuaxiangDetail/NianlinJiegou.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.nianlinjiegouData = json.data;
      });
    // 请求性别年龄
    fetch("/data/Home/QuntiHuaxiangDetail/XingbieNianlin.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.xingbienianlinData = json.data;
      });
    // 请求婚姻状态
    fetch("/data/Home/QuntiHuaxiangDetail/HunyinZhuangtai.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.hunyinzhuangtaiData = json.data;
      });
    // 请求兴趣标签
    fetch("/data/Home/QuntiHuaxiangDetail/XingquBiaoqian.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.xingqubiaoqianData = json.data;
      });
  },
  methods: {}
};
</script>

<style scoped lang="less">
.xingbiebili .chart-content {
  height: 2.4rem;
}
.line {
  width: 100%;
  height: 3rem;
  margin-bottom: 0.75rem;
  > div {
    width: 50%;
    padding: 0 0.7rem;
    box-sizing: border-box;
    height: 100%;
    float: left;
  }
}
.xingqubiaoqian {
  .chart-content {
    width: 100%;
    height: 3rem;
    ul {
      width: 100%;
      height: 100%;
      .biaotou {
        background: none !important;
      }
      li {
        width: 100%;
        height: 0.22rem;
        background: #031e3b;
        margin-bottom: 0.06rem;
        > div {
          width: 33.33%;
          float: left;
        }
        .light-text {
          color: #00ceff;
        }
      }
      li:nth-child(odd) {
        background: #0a3659;
      }
    }
  }
}
</style>
